module.exports = __webpack_public_path__ + "72cc62e9e896e691480a8fd5ef953d91.fbx";